/**
 * Offer API
 * Handles offer-related endpoints
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseAPI } from "./base-api";
export class OfferAPI extends BaseAPI {
    /**
     * Fetch detailed information about a specific offer
     */
    fetchOfferDetails(offerCode, sessionId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield this.get(`${this.env.API_V1_URL}store/offer/${offerCode}?sessionId=${sessionId}`);
                return result.data;
            }
            catch (error) {
                console.error("Error fetching offer details:", error);
                throw error;
            }
        });
    }
    /**
     * Fetch offers by brand ID
     */
    fetchOffersByBrandId(brandId, token) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            try {
                const headers = {};
                if (token) {
                    headers["authorization"] = `Bearer ${token}`;
                }
                const result = yield this.get(`${this.env.API_V1_URL}store/offer?page=1&limit=50&brandId=${brandId}`, headers);
                return ((_a = result.data) === null || _a === void 0 ? void 0 : _a.offers) || [];
            }
            catch (error) {
                console.error("Error fetching offers by brand:", error);
                throw error;
            }
        });
    }
    /**
     * Fetch offers by category ID
     */
    fetchOffersByCategoryId(categoryId, token) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            try {
                const headers = {};
                if (token) {
                    headers["authorization"] = `Bearer ${token}`;
                }
                const result = yield this.get(`${this.env.API_V1_URL}store/offer?page=1&limit=50&categoryId=${categoryId}`, headers);
                const rawOffers = ((_a = result.data) === null || _a === void 0 ? void 0 : _a.offers) || [];
                console.log("[OfferAPI] Raw offers from API:", rawOffers.length);
                // Map API response to match expected offer structure
                return rawOffers.map((apiOffer) => {
                    var _a, _b;
                    // Extract redemption method details
                    const redemptionMethod = apiOffer.redemptionMethod || {};
                    const redemptionType = redemptionMethod.type || "";
                    const redemptionDiscount = redemptionMethod.discountPercentage || "";
                    const redemptionAmount = redemptionMethod.discountAmount || "";
                    // Parse discount details from redemption method
                    const discountDetails = [];
                    if (redemptionType === "FIXED_PERCENTAGE_OFF" && redemptionDiscount) {
                        discountDetails.push({
                            percentage: parseFloat(redemptionDiscount),
                        });
                    }
                    else if (redemptionType === "FIXED_AMOUNT_OFF" && redemptionAmount) {
                        discountDetails.push({
                            amount: parseFloat(redemptionAmount),
                        });
                    }
                    console.log("[OfferAPI] Mapped offer discount:", {
                        offerName: apiOffer.offerName,
                        redemptionType,
                        redemptionDiscount,
                        redemptionAmount,
                        discountDetails,
                    });
                    return {
                        id: apiOffer.offerId || apiOffer.id || "",
                        name: apiOffer.offerName || apiOffer.name || "Unnamed Offer",
                        offerCode: apiOffer.offerCode || "",
                        price: parseFloat(apiOffer.offerPrice ||
                            apiOffer.price ||
                            apiOffer.originalPrice ||
                            "0"),
                        originalPrice: apiOffer.offerPrice ||
                            apiOffer.originalPrice ||
                            apiOffer.price ||
                            "0",
                        description: apiOffer.offerDescription || apiOffer.description || "",
                        discountType: redemptionType,
                        discountDetails: discountDetails,
                        discountPercentage: redemptionDiscount,
                        discountAmount: redemptionAmount,
                        brandName: ((_a = apiOffer.brandDetails) === null || _a === void 0 ? void 0 : _a.brandName) ||
                            apiOffer.brandName ||
                            "Unknown Brand",
                        image: apiOffer.offerImage || apiOffer.image || undefined,
                        coverImage: apiOffer.offerImage ||
                            apiOffer.coverImage ||
                            apiOffer.image ||
                            undefined,
                        websiteUrl: ((_b = apiOffer.brandDetails) === null || _b === void 0 ? void 0 : _b.websiteUrl) ||
                            apiOffer.websiteUrl ||
                            undefined,
                        productUrl: apiOffer.productUrl || undefined,
                        product: apiOffer.product || undefined,
                    };
                });
            }
            catch (error) {
                console.error("Error fetching offers by category:", error);
                throw error;
            }
        });
    }
}
